const common = {
    serverError: '서버 오류',
    networkError: '네트워크 오류',

    del: '삭제',
    rmTip: '팁 삭제',
    rmContent: '이 데이터를 삭제하시겠습니까? 삭제 후에는 데이터를 복구할 수 없습니다! ',
    rmError: '제거 실패',
    rmSuccess: '성공적으로 삭제되었습니다',

    confirm: '확인',
    cancel: '취소',
    cancelConfirm: '데이터가 변경되었습니다. 저장하지 않으시겠습니까? ',

    add: '추가',
    addError: '추가 실패',
    addSuccess: '성공적으로 추가되었습니다',

    edit: '편집',
    editError: '편집 실패',
    editSuccess: '편집 성공',
    tip: '팁',

    opt: '작업',
    viewDetail: '세부정보 보기',
    detail: '세부 사항',

    desc: '설명',
    plDesc: '설명을 입력하세요',

    pass: "통과하다",
    no: "아니요",
    copy: '복사',
    copyError: '복사 실패',
    copySuccess: '복사 성공',

    printInfo: '인쇄',
    printInfoQC: 'QC 검사서 인쇄',
    paste: '붙여넣기',
    pasteError: '붙여넣기 실패, 복사된 내용이 정상인지 확인하시거나 복사 후 다시 시도해주세요',

    select: '선택하다',
    searchError: '목록 가져오기 예외',

    timeOption12: "12시간",
    timeOption24: "1일",
    timeOption36: "36시간",
    timeOption48: "2일",
    timeOption72: "3일",
    timeOption96: "4일",
    timeOption120: "5일",
    currentTime: "현재 시간",
    selectTime: "공급업체가 견적을 낼 수 있는 기간을 선택하거나 입력하십시오.",
    or: "또는",
    inputHours: "시간 입력",
    hour: "시간",
    finalEnd: "최종 견적 마감 시간",
    upper: "현재 시간 상향 조정 후",
    plus: '더하기',

    refresh: "새로고침",
    sure: '저장하시겠습니까?',
    saveOk: '저장 성공',
    saveFAil: '저장 실패',
    save: '저장',
    notSave: '저장하지 않음',
    validateFailed: '양식 검증 실패',

    createTime: "작성 시간",
    creator: "작성자",
    updateTime: '업데이트 시간',
    updater: '수정자',
    pleaseTryAgain: '나중에 다시 시도해주세요',
    operationFailed: '작업 실패',

    exportCurrentPage: '현재 페이지를 Excel로 내보내기',
    exportAllExcel: '전체를 Excel로 내보내기',
    exporting: '내보내는 중',
    exportingTip: '일괄 데이터 로드 중, 잠시 기다려 주세요...',
    exportErr: '내보내기 실패',
    warning: '경고',
    pleaseSelectColumns: '내보낼 열을 하나 이상 선택하세요',
    selectAll: '모두 선택',
    expand: '더 보기',
    collapse: '접기',

    basicInfo: '기본 정보',
    attachment: '첨부 파일',
    noOutOrder: '출고 주문 없음',
    deleteSuccess: '삭제 성공',
    deleteFail: '삭제 실패',
    batchDel: '일괄 삭제',
    selectLeastOne: '최소 하나 이상 선택해주세요',
    versionFalse: "요청 실패. 버전이 올바르지 않습니다. 페이지를 새로 고친 후 다시 시도해 주십시오.",
    po: "구매 주문",
    poi: "구매 주문 항목",
    so: "판매 주문",
    soi: "판매 주문 항목",
    io: "입고 주문",
    ioi: "입고 주문 항목",
    oo: "출고 주문",
    ooi: "출고 주문 항목",
    co: "실사 주문",
    coi: "실사 주문 항목",
    act: "미수금",
    acti: "미수금 항목",
    pay: "미지급금",
    payi: "미지급금 항목",
    req: "수요 주문",
    reqi: "수요 주문 항목",
    quo: "문의 주문",
    loc: "로케이션",
    sp: "판매 가격",
    pp: "구매 가격",
    cd: "실사 차이",
    user: "사용자",
    org: "조직",
    supplier: "공급업체",
    bom: "BOM",
    pl: "생산 계획",
    reqest: "신청",
    export: "내보내기",
    inventories: "납품서",
    matPurTmp: "구매 주문 매칭 템플릿 다운로드",
    genPuInv: "구매 주문 매칭으로 납품서 생성",
    suppInv: "공급업체 매칭으로 납품서 생성",
    printSaleIn: "완제품 입고 인쇄",
    saleIn: "완제품 입고",
    lotGetErr: "배치 생성 실패, 관리자에게 문의하세요",
    addNext: "다음",
    genLot: "생성",
    noCodeWarn: "재고 코드가 없는 항목은 배치가 생성되지 않습니다",
    genAllLot: "일괄 배치 생성",
    colSet: "표시 열 선택",
    leastSetOneCol: "최소 하나의 열을 선택해야 합니다!",
    reqCanceled: "조회 요청이 취소되었습니다",
    escPressed: "ESC를 눌러 조회 요청이 취소되었습니다",
    noFiles: "파일 없음",
};

export default common;
